<div class="w-full">
    <!-- Tab Headers -->
    <div class="overflow-x-auto whitespace-nowrap border-b border-gray-300 bg-gray-100 text-sm font-medium font-gotham">
      <div class="flex flex-nowrap w-max">
        <ng-container *ngFor="let key of tabKeys">
          <button
            class="px-6 py-4 border-b-4 transition-colors font-[500] duration-200 whitespace-nowrap"
            [class.border-yellow-400]="selected === key"
            [class.bg-white]="selected === key"
            [class.text-black]="selected === key"
            [class.text-gray-600]="selected !== key"
            (click)="select(key)">
            {{ key }}
          </button>
        </ng-container>
      </div>
    </div>

    <!-- Tab Content -->
    <div class="py-8">
      <ng-container *ngTemplateOutlet="selectedTemplate"></ng-container>
    </div>
  </div>
